<script setup lang="ts">
/**
 * Minimal layout for printable canvas pages.
 *
 * Strips the default chrome (sidebar, top bar, breadcrumbs) so the page
 * contains only the printable content — the print button and the stacked
 * canvas print pages.
 *
 * Dark mode is always suppressed here so print preview and print-to-PDF
 * render in light mode regardless of the user's theme preference.
 */
import { overrideLightMode } from '~/composables/useDarkMode'

onMounted(() => overrideLightMode(true))
onBeforeUnmount(() => overrideLightMode(false))
</script>

<template>
  <main :class="$style.root">
    <slot />
  </main>
</template>

<style module>
.root {
  min-height: 100vh;
  background: var(--color-accent-200);
  padding: 8mm 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media print {
  .root {
    padding: 0;
    background: transparent;
  }
}
</style>
